<template>
  <modal name="ticketMotivoAberturaEdit" height="auto" width="900" :lazy="true" :scrollable="true"
    :clickToClose="false">
    <CloseModal :close="close" />
    <div class="modalbox">
      <div class="modalbox-content">
        <div class="xrow">
          <div class="col-1-2">
            <div class="form-group">
              <label>Descrição</label>
              <input type="text" class="form-control" v-model="item.descricao" />
              <div v-if="!showRootId">A descrição para o nível deve seguir o nome do Tipo de Ticket (Aba Tipos Ticket e
                Etapas)</div>
            </div>
          </div>
          <div class="col-1-4">
            <div class="form-group">
              <label>Nivel</label>
              <input class="form-control" type="number" min="1" v-model="item.nivel"></input>
            </div>
          </div>
          <div class="col-1-4">
            <div class="form-group">
              <label>Obrigatorio</label>
              <select class="form-control" v-model="item.obrigatorio">
                <option :value="1">Sim</option>
                <option :value="0">Não</option>
              </select>
            </div>
          </div>
        </div>
        <div class="xrow" v-if="showRootId">
          <div class="col-1-2">
            <div class="form-group">
              <label>Tipo Ticket Pai</label>
              <select class="form-control" v-model="item.root_id">
                <option v-for="nivel in niveis" :key="nivel.id" :value="nivel.id">
                  {{ nivel.descricao }} (ID: {{ nivel.id }})
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" :class="{
        'button button-success': true,
        'button-disabled': validation.hasError(),
      }" v-on:click="handleSubmit()">
        Salvar Alterações
      </button>
      <button type="button" class="button" v-on:click="close">
        Fechar
      </button>
    </div>
  </modal>
</template>

<script>
import SimpleVueValidation from "simple-vue-validator";
import _keyBy from "lodash/keyBy";
import CloseModal from "../../../../components/CloseModal";
import { get } from "@/helpers/apiRequest";

const Validator = SimpleVueValidation.Validator.create({
  templates: {
    required: "Campo de preenchimento obrigatório",
  },
});

export default {
  name: "bannerEdit",
  components: {
    CloseModal,
  },
  props: [
    "onClose",
    "onSubmit",
    "item",
    "close",
  ],
  data() {
    return {
      niveis: [],
      showRootId: true,
    };
  },
  validators: {
    "item.descricao": (value) => Validator.value(value).required(),
    "item.nivel": (value) => Validator.value(value).required(),
    "item.obrigatorio": (value) => Validator.value(value).required(),
  },
  watch: {
    "item.nivel"(value) {
      if (Number(value) === 1) {
        this.item.root_id = null;
        this.showRootId = false;
        return;
      }
      this.showRootId = true;
      this.getNiveis(Number(value) - 1);
    },
  },
  methods: {
    getNiveis(nivel) {
      get(`/admin/sac/ticket/motivo/abertura/nivel/${nivel}`).then((json) => {
        this.niveis = json;
      });
    },
    handleSubmit() {
      this.$validate().then((success) => {
        if (success) {
          this.onSubmit(this.item).catch((error) => {
            this.$swal({
              title: "Falha ao salvar alterações",
              text: error.message,
              showCancelButton: false,
              cancelButtonText: "Fechar",
              showConfirmButton: true,
              icon: "error",
            });
          });
        }
      });
    },
  }
};
</script>
